export const isBrowser = {
  get firefox() {
    return navigator.userAgent.includes('Firefox');
  },
  get chrome() {
    return navigator.userAgent.includes('Chrome');
  },
  get safari() {
    return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Chromium');
  },
};
